/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_EmptyInputs */

const cs_audit_empty = /** @type {(inputs: Audit_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné auditní události. Nové akce v Cerebriu se sem propíšou automaticky.`)
};

const en_audit_empty = /** @type {(inputs: Audit_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audit events. New actions in Cerebrio appear here automatically.`)
};

/**
* | output |
* | --- |
* | "No audit events. New actions in Cerebrio appear here automatically." |
*
* @param {Audit_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_empty = /** @type {((inputs?: Audit_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_empty(inputs)
	return cs_audit_empty(inputs)
});